import {gql} from "@apollo/client";
import { DeliveryTaskOrderType, DELIVERY_TASK_ORDER_FIELDS } from "../types/DeliveryTaskOrderType";
import { client } from "graphql/client";

export const NEW_ASSIGNMENT_DELIVERY_SCAN = gql`
  mutation DeliveryMutation($input: ScanInput!) {
    result: handleNewAssignmentDeliveryScanEvent(input: $input) {
      ...DeliveryTaskOrderFields
    }
  }
  ${DELIVERY_TASK_ORDER_FIELDS}
`;

interface NewAssignmentDeliveryScanResponse {
    result: DeliveryTaskOrderType;
}

export interface NewAssignmentScanInput {
    trackingNumber: string;
    scanLocation: {
        latitude: number;
        longitude: number;
    };
}

interface NewAssignmentScanInputVariables {
    input: NewAssignmentScanInput;
}

export const handleNewAssignmentDeliveryScanEvent = async (input: NewAssignmentScanInput): Promise<DeliveryTaskOrderType | undefined>  => {
    const { data } = await client.mutate<NewAssignmentDeliveryScanResponse, NewAssignmentScanInputVariables>({
        mutation: NEW_ASSIGNMENT_DELIVERY_SCAN,
        variables: { input },
    });
    return data?.result;
};